var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-sm table-hover table-bordered"},[_c('thead',[_vm._t("head")],2),_c('tbody',[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }